import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { filterTopicsByTopPicks, sortItemsByTitle } from 'tw-oi-core/utils/data'
import { trackTopPicksTopicClick } from 'tw-oi-core/services/analytics'

import { MESSAGE, ROUTE } from '../config'

import { connect } from 'react-redux'
import ScreenHead from '../components/ScreenHead'
import ScreenContainer from '../components/ScreenContainer'
import ContentList from '../components/ContentList'
import Loader from '../components/Loader'
import Media from '../components/Media'

import '../styles/Topics.scss'

const RECOMMENDED_TITLE = 'Recommended'

class TopPicks extends Component {

  static propTypes = {
    fetching: PropTypes.bool,
    topics: ImmutablePropTypes.list,
    currentYear: PropTypes.string,
    currentModel: PropTypes.string,
    currentBrand: PropTypes.string,
    match: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  }

  handleTopicClick = topic => {
    trackTopPicksTopicClick(topic.title)
  }

  render() {
    const { topics, fetching, currentYear, currentBrand, currentModel, match } = this.props

    // Guide root is the parent of /top-picks — strip the trailing route segment
    // so the back button lands on the model's overview page on mobile.
    const guideRoot = match.url.endsWith(ROUTE.TOPPICKS)
      ? match.url.slice(0, -ROUTE.TOPPICKS.length)
      : match.url

    if (fetching || !topics) {
      return (
        <div className='Topics'>
          <ScreenHead back={guideRoot} backTitle='Back'>
            <em>{currentYear} {currentBrand}</em>
            <span>{currentModel}</span>
          </ScreenHead>
          <div className='screen-content'>
            <Loader type='auto' />
          </div>
        </div>
      )
    }

    const sortedTopPicks = sortItemsByTitle(filterTopicsByTopPicks(topics))

    return (
      <div className='Topics'>
        <ScreenHead back={guideRoot} backTitle='Back'>
          <em>{currentYear} {currentBrand}</em>
          <span>{currentModel}</span>
        </ScreenHead>

        <Media type='mobile'>
          <div className='topics-subtitle'>{RECOMMENDED_TITLE}</div>
        </Media>

        <div className='screen-content'>
          <ScreenContainer currentUrl={match.url}>
            <div className='topics'>
              <ContentList
                topics={sortedTopPicks.toJS()}
                emptyText={MESSAGE.EMPTY_TOPICS}
                baseRoute={match.url}
                className='TopPicksList'
                onClick={this.handleTopicClick}
              />
            </div>
          </ScreenContainer>
        </div>
      </div>
    )
  }
}

function mapStateToProps({ contents, vehicle }) {
  const { topics, fetching } = contents
  const { currentYear, currentModel, currentBrand } = vehicle

  return { topics, fetching, currentYear, currentModel, currentBrand }
}

export default connect(mapStateToProps)(TopPicks)
